import { Ability } from '@casl/ability'
import { initialAbility } from './config'

let userData = null

try {
  userData = JSON.parse(localStorage.getItem('userData'))
} catch (e) {
  userData = null
}

const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
